module.exports = __webpack_public_path__ + "img/cloud-sun.8ec0c15a.svg";